import { Capability } from '../../core/models/user-capability';
import { useAppSelector } from '../../core/store/root.store';
import { selectUser } from '../../core/state/user.slice';

export default function (capability: Capability): boolean {
  return useAppSelector(selectUser)?.capabilities?.includes(capability) ?? false;
}
